import React from 'react';
import {getIndexProtectorLabel} from "../../shared/common";
import './AdditionalCalculatorInfo.css';
import {connect} from "react-redux";

const additionalCalculatorInfo = (props) => {

    const indexProtector = props.indexProtector ? props.indexProtector : 5;
    const isIAAndIAA = indexProtector.indexOf("INDEX ACHIEVER") !== -1 ? true : false;

    return (
        <div>

            <div className="additional-calcuator-page page">
                <p>
                    The inStream Plan Comparison<sup>1</sup> provides statistical highlights from a large group of
                    projections produced
                    by a simulator that applied performance simulations to two similar user-created investment
                    portfolios
                    over
                    a hypothetical ten-year period<sup>2</sup>. The simulator took the following
                    factors<sup>3</sup> into
                    account when producing the
                    projections: (1) performance information for preselected Morningstar categories, relevant indices,
                    and
                    relevant investment funds over a recent 17-year period<sup>4</sup>, (2) the user’s beginning
                    portfolio
                    balance, asset
                    class allocation, and short-term market prediction inputs, and (3) investment features specific to
                    annuities under consideration.
                </p>

                <p>
                    The simulator first assembled monthly return data from a recent 17-year period for 22 Morningstar
                    categories<sup>5</sup> and the indices corresponding to the indexed strategies available under the &nbsp;
                    {getIndexProtectorLabel(props.indexProtector)}
                    (“Asset Categories”). From these data sets, the simulator calculated: (1) the historical variance of
                    the
                    monthly returns within each Asset Category (“Variation Characteristics”), (2) the historical
                    correlation
                    of the monthly returns among each Asset Category (“Correlation Characteristics”), and (3) the
                    calendar
                    year returns for each Asset Category. For each of the seven fixed-income Morningstar categories, the
                    simulator also assembled the effective duration and 12-month yield for a benchmark investment fund
                    similar to the category<sup>6</sup> (“Benchmark Fund’).
                </p>

                <p>
                    From this information, the simulator computed return amounts using the following methodologies in
                    order
                    to define expected returns for five<sup>7</sup> market trend classifications (“Market Trend
                    Classifications”) for
                    equity and fixed-income sectors<sup>8</sup>:
                </p>

                <div className="additional-calculator-footnotes page">
                    <ul>
                        <li>
                            1. The Plan Comparisons are intended to illustrate the potential benefits an investor could
                            derive from replacing a portion of their portfolio with an annuity. The Plan Comparisons
                            have no
                            predictive value and are for illustration purposes only.
                        </li>
                        <li>
                            2. Past performance does not necessarily predict future results. Different investments
                            involve
                            varying degrees of risk, and there can be no assurance that the future performance of any
                            specific investment, investment strategy, or product will be profitable, emulate historical
                            performance, or be suitable for any individual situation. MassMutual Ascend Life Insurance
                            Company
                            makes no representation as to the financial or other suitability of any product or service
                            described herein.
                        </li>
                        <li>
                            3. Each factor and assumption was essential to the projections produced by the simulator.
                            Inaccurate assumptions can significantly diminish the precision of the projections. MassMutual Ascend
                            Insurance Company makes no representations or warranties regarding the
                            accuracy of
                            the assumptions, historical data, or calculations used by the simulator, or of the
                            simulations,
                            projections, and highlights produced by such assumptions, data, and calculations.
                        </li>
                        <li>
                            4. Performance information was compiled for a recent 17-year period. This period was
                            selected in
                            order to incorporate long-term data from recent market cycles, but longer and more recent
                            performance information could be available that could alter the assumptions upon which the
                            simulations are based.
                        </li>
                        <li>
                            5. The 22 Morningstar categories include 14 equity categories, 7 fixed-income categories,
                            and 1
                            commodity category.
                        </li>
                        <li>
                            6. Because effective duration and 12-month yield statistics are not available for
                            fixed-income
                            Morningstar categories, inStream has selected each Benchmark Fund to serve as an analog.
                            Each
                            Benchmark Fund is an exchange-traded fund managed using an investment strategy that is
                            similar
                            to the strategies employed by funds in the relevant Morningstar category. The portfolio
                            composition and performance of each Benchmark Fund will differ from the funds in the
                            relevant
                            Morningstar category. The extent of such differences will directly diminish the accuracy of
                            the
                            assumptions used by the simulator related to the expected returns of fixed-income Asset
                            Categories.
                        </li>
                        <li>
                            7. To simplify the use of the simulator, the number of Market Trend Classifications has been
                            limited to five, but the full spectrum of market trend classifications could be divided into
                            far
                            more than five categories. Because the Market Trend Classifications have been defined
                            broadly,
                            significant differences exist between the returns assigned to each Market Trend
                            Classification.
                            As a result, Market Trend Classification selection will often have a significant impact on
                            expected returns.
                        </li>
                    </ul>
                </div>
            </div>

            <div className="additional-calcuator-page page">

                <table className="market-trend-table">
                    <thead>
                    <tr>
                        <th className="market-trend-header">Market Trend Classifications</th>
                        <th className="market-trend-header">Asset Classes</th>
                        <th>Methodology Used to Define Expected Returns</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td>Big Bear:</td>
                        <td>Fixed-Income<sup>9</sup>:</td>
                        <td>The relevant Benchmark Fund’s average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 300 bps interest rate increase.
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>All Others<sup>10</sup>:</td>
                        <td>Monthly return of the Asset Category ranked at the 10th percentile over the 10-year historical period (meaning 90% of all monthly returns over the 10-year period were larger) </td>
                    </tr>
                    <tr className="odd-entry">
                        <td>Little Bear:</td>
                        <td>Fixed-Income:</td>
                        <td>	
                            The relevant Benchmark Fund’s average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 150 bps interest rate increase.
                        </td>
                    </tr>
                    <tr className="odd-entry">
                        <td></td>
                        <td>All Others:</td>
                        <td>Monthly return of the Asset Category ranked at the 25th percentile</td>
                    </tr>
                    <tr>
                        <td>Normal:</td>
                        <td>Fixed-Income:</td>
                        <td>Benchmark Fund’s average Yield to Maturity</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>All Others:</td>
                        <td>Average of annual returns of the Asset Category over 10-year historical period</td>
                    </tr>
                    <tr className="odd-entry">
                        <td>Little Bull:</td>
                        <td>Fixed-Income:</td>
                        <td>The relevant Benchmark Fund’s average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 150 bps interest rate decrease
                        </td>
                    </tr>
                    <tr className="odd-entry">
                        <td></td>
                        <td>All Others:</td>
                        <td>Monthly return of the Asset Category ranked at the 75th percentile</td>
                    </tr>
                    <tr>
                        <td>Big Bull:</td>
                        <td>Fixed-Income</td>
                        <td>The relevant Benchmark Fund’s average Yield to Maturity, adjusted for duration and convexity, incorporating the effects of a 300 bps interest rate decrease.</td>
                    </tr>
                    <tr>
                        <td></td>
                        <td>All Others:</td>
                        <td>Monthly return of the Asset Category ranked at the 90th percentile</td>
                    </tr>
                    </tbody>
                </table>

                <div className="additional-calculator-footnotes">
                    <ul>
                        <li>
                            8. In order to simplify the use of the simulator, Market Trend Classifications can only be
                            selected for Asset Categories that fall into two broad sectors: equity and fixed-income.
                            This means that expected returns were determined for all equity Asset Categories using the
                            same methods, even though market characteristics underlying each trend can affect individual
                            equity Asset Categories differently. The methods used by the simulator are intended to
                            minimize such disparate effects, but cannot eliminate them entirely. As a result, the
                            precision of expected returns is diminished by the limited number of sectors to which Market
                            Trend Classifications can be applied.
                        </li>
                        <li>
                            9. To reflect the unusual nature and results of the long-term downward interest rate trend
                            over the 17-year historical period, the simulator assigned the 17-year average return to the
                            strongest Market Trend Classification (Big Bull), instead of the Normal Market Trend
                            Classification, for each fixed-income Asset Category. The 12-month yield of the Benchmark
                            Fund was determined to provide a more accurate reflection of normal market trends. The
                            normal market returns for fixed income implicitly assume that interest rates do not change.
                            From those normal market trend returns, the simulator assigned return values to the Little
                            Bull, Little Bear, and Big Bear categories based on assumed interest rate fluctuations of
                            -25 bps, +100 bps, and +200 bps, respectively, which were selected by inStream based on
                            observations of historical interest rate fluctuations. Any adjustment to these decisions and
                            assumptions would have a significant impact on the expected returns defined for each
                            Fixed-Income Market Trend Classification.
                        </li>
                        <li>
                            10. Since market trends over the 17-year historical period were less anomalous for all other
                            asset classes than for the fixed-income market cycle, return values for all other Market
                            Trend Classifications were defined using the average returns over the 17-year period for the
                            Normal Market Trend Classification, and 10th, 25th, 75th, and 90th percentile ranks for each
                            of the other Market Trend Classifications. Each percentile rank was selected based on
                            inStream’s inferences from historical market performance. Any adjustment to these decisions
                            and assumptions would have a significant impact on the expected returns defined for each
                            relevant Market Trend Classification.
                        </li>
                    </ul>
                </div>
            </div>

            <div className="additional-calcuator-page">

                <p>
                    The return figures assigned to each Market Trend Classification, along with the Variation
                    Characteristics and Correlation Characteristics, were then used to produce a sufficiently large
                    number of simulations of the annual performance of each Asset Category, resulting in 5,000
                    simulations for each Asset Category over each of the next ten years.
                </p>

                <ul>
                    <li>
                        For Years 1-3 of each simulation<sup>11</sup> , the simulator used a normal distribution to
                        produce sample
                        returns for each Asset Category based on returns assigned to the Market Trend Classification
                        selected by the user, along with the Variation Characteristics and the Correlation
                        Characteristics.
                    </li>
                    <li>
                        For each simulation in Years 4-10, the simulator used a normal distribution to produce sample
                        returns for each Asset Category using returns assigned to the Normal Market Trend Classification<sup>12</sup>
                        ,along with the Variation Characteristics and the Correlation Characteristics.
                    </li>
                </ul>

                <p>
                    The simulator then applied each of the 50,000 performance simulations to two scenarios.
                </p>

                <ul>
                    <li>
                        In the first scenario, an investment portfolio was constructed using beginning value and
                        allocation information entered by the user, producing a return figure for the portfolio in each
                        simulation. The “Current Plan” column contains information related to this data set.
                    </li>
                    <li>
                        In the second scenario, the simulator applied the same performance simulations to a similar
                        investment portfolio that includes {isIAAndIAA ? "registered index-linked annuity indexed strategies offered by the " : "fixed-indexed annuity crediting strategies offered by the "} {getIndexProtectorLabel(props.indexProtector)}. The selected {isIAAndIAA ? "" : "fixed-"}indexed strategies replace certain of
                        the investments in
                        the Current Plan portfolio <sup>13</sup> . For any portion of the portfolio allocated to an
                        indexed strategy,
                        the simulator modified the returns of the underlying index or fund to account for the features
                        of the strategy<sup>14</sup> that cause its performance to diverge from the performance of the
                        underlying
                        index. The "With {isIAAndIAA ? getIndexProtectorLabel(props.indexProtector) : "Index Protector"}" column contains information related to this data set.
                    </li>
                </ul>

                <div className="additional-calculator-footnotes">
                    <ul>
                        <li>
                            11. In order to simplify use of the simulator, it was assumed that the user-assigned Market
                            Trend Classifications would apply only during the first three years of the hypothetical
                            ten-year period. This assumption reflects the short duration of most market trends, but the
                            duration of actual market trends will often vary from this assumption. Any modification to
                            the duration of the user-assigned Market Trend Classifications would have a significant
                            impact on the resulting projections.
                            Under the assumption that the returns of a portfolio will revert to the mean over time, the
                            returns during the final seven years of the ten-year period were calculated using Normal
                            Market Trend Classifications. The duration of actual market trends will vary, however. Any
                            modification to the duration of the Normal Market Trend Classification would have a
                            significant impact on the resulting projections.
                        </li>
                        <li>
                            12. Under the assumption that the returns of a portfolio will revert to the mean over time,
                            the returns during the final seven years of the ten-year period were calculated using Normal
                            Market Trend Classifications. The duration of actual market trends will vary, however. Any
                            modification to the duration of the Normal Market Trend Classification would have a
                            significant impact on the resulting projections.
                        </li>
                        <li>
                            13. When producing the second scenario, the simulator by default replaces investments in
                            Asset Categories from the first scenario based on the investments that have the lowest
                            correlations with the selected interest strategies. Generally, this involves first replacing
                            investments in fixed-income Asset Categories. The user can override these default
                            replacement settings. Any differences between the default and user-selected replacement
                            settings would produce different results.
                        </li>
                        {(isIAAndIAA && props.indexProtector === "INDEX ACHIEVER") && (
                            <li>
                                14. Applicable caps, floors and buffers are applied to the simulated returns for the
                                interest strategies as required under the annuity contract. The simulator assumed that
                                these variables would remain static over the hypothetical ten-year period, but these
                                variables are subject to change and can vary from term to term and by product. If the
                                variables of the interest strategies varied significantly from this simulator’s static
                                assumptions, the resulting simulations would vary significantly as well. For the
                                interest strategies available through the Index Achiever, the declared rates and caps
                                will never be below 1.00%.
                            </li>
                        )}
                        {(isIAAndIAA && props.indexProtector === "INDEX ACHIEVER ADVISORY") && (
                            <li>
                                14. Applicable caps, upside participation rates, floors, buffers and downside participation
                                rates are applied to the simulated returns for the interest strategies as required under
                                the annuity contract. The simulator assumed that these variables would remain static
                                over the hypothetical ten-year period, but these variables are subject to change and can
                                vary from term to term and by product. If the variables of the interest strategies
                                varied significantly from this simulator’s static assumptions, the resulting simulations
                                would vary significantly as well. For the interest strategies available through the
                                Index Achiever Advisory, the declared rates and caps will never be below 1.00% and the
                                upside participation rates will never be lower than 5%.
                            </li>
                        )}
                        {!isIAAndIAA && (
                            <li>
                                14. Caps, and participation rates are applied to the simulated returns for
                                the interest strategies as required under the annuity contract. The simulator assumed that
                                these variables would remain static over the hypothetical ten-year period, but these
                                variables are subject to change and can vary from term to term and by product. <br />Between
                                August 2016 (when the Index Protector series was launched with {props.indexProtector}) and
                                December 2019, the actual declared rates, caps and participation rates for the interest
                                strategies available through the Index Protector series fell into the following ranges:
                                declared rates ranged from 1.25% to 3.60%, caps ranged from 4.00% to 9.00%, and
                                participation rates ranged from 45% to 100%. If the variables of the interest strategies
                                varied significantly from this simulator’s static assumptions, the resulting simulations
                                would vary significantly as well. For the interest strategies available through the Index
                                Protector series, the declared rates and caps will never be below 1.00% and the
                                participation rates will never be lower than 5%.
                            </li>
                        )}
                        <li>
                            Calculations do not take into account advisory fees. Advisory fees paid on assets under management would impact results
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    )
};

const mapStateToProps = (state) => {
    return {
        companyName: state.globalState.companyName
    }
};

export default connect(mapStateToProps)(additionalCalculatorInfo);


// WEBPACK FOOTER //
// ./src/components/AdditionalCalculatorInfo/AdditionalCalculatorInfo.js